"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
exports.default = vue_1.default.extend({
    name: 'UndergroundTokens',
    components: {
        UndergroundToken: () => Promise.resolve().then(() => require('./UndergroundToken.vue')),
    },
    props: {
        underworldData: {
            type: Object,
        },
    },
    methods: {
        border(token) {
            return token.active ? 'underground-token-border' : '';
        },
    },
});
